import React, {Context, createContext} from 'react';
import INavItem from '../Interfaces/INavItem';

export default createContext<{items: INavItem[], selectedNav?: INavItem, selectNav?: (item: string) => void}>({
    items: [],
    selectedNav: undefined,
    selectNav: undefined
});